const initialState = () => {
    return {
        /**
         * @description
         * List of families with nested subfamilies, pulled from DB to be shown in
         * family/subfamily selection controls
         */
        families: [],
        /**
         * @description
         * list of communes pulled from DB to be shown in commune selection controls
         */
        communes: [],
        /**
         * @description
         * list of available warehouses for the current user, to be pulled from the DB
         */
        warehouses: [],
        /**
         * @description
         * List of available branch offices for the current user, to be pulled from DB
         * for office selection controls
         */
        branch_offices: [],
    }
}

export default initialState
